import {Observable} from 'rxjs';
import {Ota} from './ota.model';
import {Availibility} from './availibility.model';
import {IParamsSearch} from '@app/shared/interfaces/iparams-search.interface';

export class SearchDispo {
    otas: Array<Observable<Ota>> = [];
    dispo$: Observable<Availibility> = null;
    allComapartors$: Observable<any> = null;
    tokenSearch: string;
    private paramsSearch: IParamsSearch;

    setParamsSearch(paramsSearch: IParamsSearch): SearchDispo {
        this.paramsSearch = paramsSearch;
        return this;
    }

    getParamsSearch(): IParamsSearch {
        return this.paramsSearch;
    }
}